import { RECEIVE_QA } from '../action/qa'

const initialState = {
  qa: null,
}

export default (state = initialState, action) => {
  switch(action.type){
    case RECEIVE_QA:
      return {
        ...state,
        qa: action.qa
      }
    default:
      return state
  }
}
